import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-input-interval label-mono-m" }
const _hoisted_2 = { class: "n-input-interval__icon" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider__text" }, "—")
], -1)
const _hoisted_4 = { class: "n-input-interval__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NIcon = _resolveComponent("NIcon")!
  const _component_NInputNumber = _resolveComponent("NInputNumber")!
  const _component_NDropdownInput = _resolveComponent("NDropdownInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "n-input-interval__min",
      onKeyup: [
        _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleDisplayMinDropdown && _ctx.toggleDisplayMinDropdown(...args)), ["enter"])),
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.minValueEscKeyupHandler && _ctx.minValueEscKeyupHandler(...args)), ["esc"]))
      ],
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleDisplayMinDropdown && _ctx.toggleDisplayMinDropdown(...args)))
    }, [
      _createVNode(_component_NInputNumber, _mergeProps(_ctx.$props, {
        "model-value": _ctx.currentMinValue,
        textAlign: "right",
        controls: false,
        readonly: _ctx.readonly,
        autofocus: true,
        ref: "min",
        key: "min"
      }), _createSlots({ _: 2 }, [
        (_ctx.controlType)
          ? {
              name: "suffix",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_NIcon, {
                    class: "n-input-interval__icon_suffix",
                    name: _ctx.controlType,
                    width: "20",
                    height: "20"
                  }, null, 8, ["name"])
                ])
              ])
            }
          : undefined
      ]), 1040, ["model-value", "readonly"]),
      (_ctx.displayMinDropdown && !_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_NDropdownInput, {
            key: 0,
            items: _ctx.getModifiedValues(_ctx.currentMinValue),
            value: _ctx.currentMinValue,
            disabled: _ctx.disabled,
            onChange: _ctx.minValueChangeHandler
          }, null, 8, ["items", "value", "disabled", "onChange"]))
        : _createCommentVNode("", true)
    ], 32),
    _hoisted_3,
    _createElementVNode("div", {
      class: "n-input-interval__max",
      onKeyup: [
        _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.toggleDisplayMaxDropdown && _ctx.toggleDisplayMaxDropdown(...args)), ["enter"])),
        _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.maxValueEscKeyupHandler && _ctx.maxValueEscKeyupHandler(...args)), ["esc"]))
      ],
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleDisplayMaxDropdown && _ctx.toggleDisplayMaxDropdown(...args)))
    }, [
      _createVNode(_component_NInputNumber, _mergeProps(_ctx.$props, {
        "model-value": _ctx.currentMaxValue,
        textAlign: "right",
        controls: false,
        readonly: _ctx.readonly,
        autofocus: true,
        ref: "max",
        key: "max"
      }), _createSlots({ _: 2 }, [
        (_ctx.controlType)
          ? {
              name: "suffix",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_NIcon, {
                    class: "n-input-interval__icon_suffix",
                    name: _ctx.controlType,
                    width: "20",
                    height: "20"
                  }, null, 8, ["name"])
                ])
              ])
            }
          : undefined
      ]), 1040, ["model-value", "readonly"]),
      (_ctx.displayMaxDropdown && !_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_NDropdownInput, {
            key: 0,
            items: _ctx.getModifiedValues(_ctx.currentMaxValue),
            value: _ctx.currentMaxValue,
            disabled: _ctx.disabled,
            onChange: _ctx.maxValueChangeHandler
          }, null, 8, ["items", "value", "disabled", "onChange"]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}